/*
This contains helper methods to performance operations using keyboard
 */

import { ENTITY_TYPE } from '@/constants/entities'
import { DEFAULT_EFFORT, DEFAULT_IMPACT, DEFAULT_REACH, IDEA_ROW } from '@/constants/idea'
import { IDEA_LIST_ROW } from '@/constants/ideaList'
import { getIdeaListPageRouteConfig, getIdeaRowPageRouteConfig } from '@/utils/navigationConfigs'
import * as R from 'ramda'
import * as keymapService from '@/services/keymapService/keymapService'
import scrollToElement from '@/utils/scrollToElement'
import { EVENT_ACTION, EVENT_CATEGORY, EVENT_NAME } from '@/constants/analytics'
import { trackEvent } from '@/analytics'

export default {
  methods: {
    addNewIdea(ideaList) {
      let newIdea = {
        id: this.createIdeaId(),
        title: '',
        impact: DEFAULT_IMPACT,
        effort: DEFAULT_EFFORT,
        reach: DEFAULT_REACH,
        coOwnerIds: ideaList.coOwnerIds,
        ownerId: ideaList.ownerId,
        isDone: false
      }
      this.$emit('update-ideas', R.append(newIdea, this.ideas))
    },
    getSelectedIdeaVueComponent() {
      let selectedItem = this.$el.querySelector('.selected')
      if (selectedItem) {
        return selectedItem.__vue__
      }
    },
    scrollToSelectedElement() {
      const selectedElement = keymapService.selectedListItem(this.$el)
      scrollToElement(selectedElement)
    },
    selectPreviousItem(event) {
      event.preventDefault()
      keymapService.selectListItem(this.$el, 'previous')
      document.activeElement.blur()
      this.focusTabPin()
      this.scrollToSelectedElement()
    },
    selectNextItem(event) {
      event.preventDefault()
      keymapService.selectListItem(this.$el, 'next')
      document.activeElement.blur()
      this.focusTabPin()
      this.scrollToSelectedElement()
    },
    editIdea(event) {
      event.preventDefault()
      let idea = this.getSelectedIdeaVueComponent()
      if (idea) {
        idea.editable = true
      }
    },
    viewItem(event, entityType) {
      if (entityType === ENTITY_TYPE.IDEA_LIST) {
        const selectedItem = keymapService.selectedListItem(this.$el)
        const ideasListId = selectedItem.dataset.ideaListId
        const location = getIdeaListPageRouteConfig({
          orgId: this.orgId,
          listId: ideasListId
        })
        this.$router.push(location)
      } else {
        const isDropdownField = event.target.classList.contains('dropdown-item')
        const isDropdownMenu = event.target.classList.contains('dropdown-menu')
        const isOwnerField = event.target.classList.contains('owner')
        const isDueDateField = event.target.classList.contains('due-date-field')
        if (![isDropdownField, isDropdownMenu, isOwnerField, isDueDateField].some(Boolean)) {
          const selectedItem = keymapService.selectedListItem(this.$el)
          const ideasId = selectedItem.dataset.ideaId
          const location = getIdeaRowPageRouteConfig({
            orgId: this.orgId,
            ideaId: ideasId
          })
          this.$router.push(location)
        }
      }
    },
    doneUndone(event) {
      const ideaVue = this.getSelectedIdeaVueComponent()
      if (
        ideaVue &&
        (!ideaVue.$el.contains(document.activeElement) ||
          document.activeElement.classList.contains('tab-pin'))
      ) {
        event.preventDefault() // prevent scroll
        const idea = ideaVue.idea
        ideaVue.changeStatus(!idea.isDone)
      }
    },
    toggleItem: function(expanded) {
      const selectedItem = keymapService.selectedListItem(this.$el)
      if (selectedItem) {
        let selectedItem = this.$el.querySelector('.selected')
        const vueNode = selectedItem.__vue__
        vueNode.expanded = typeof expanded === 'undefined' ? !vueNode.expanded : expanded
        setTimeout(() => selectedItem.classList.add('selected'), 100)
      }
    },
    expandItem() {
      this.toggleItem(true)
    },
    collapseItem() {
      this.toggleItem(false)
    },
    /**
     * This focuses the tab-pin of selected row, so that tab-key can take focus to next status checkbox
     * @returns {Vue}
     * @type {Element}
     */
    focusTabPin() {
      const selected = this.$el.querySelector('.idea-row.selected')
      if (selected) {
        const tabPin = selected.querySelector('.tab-pin')
        tabPin &&
          tabPin.focus({
            preventScroll: true
          })
      }
    },
    /**
     * This function accepts a DOM node inside idea row and it will return the reference of Vue component for the idea
     * @param node
     * @returns {null|*|null|*}
     */
    getIdeaRowVue(node) {
      if (!node) return null
      if (R.pathEq(['__vue__', '$options', 'name'], IDEA_ROW, node)) {
        return node.__vue__
      } else return this.getIdeaRowVue(node.parentElement)
    },
    /**
     * This function accepts a DOM node inside idea list row and it will return the reference of Vue component for the Idea List
     * @param node
     * @returns {null|*|null|*}
     */
    getIdeaListRowVue(node) {
      if (!node) return null
      if (R.pathEq(['__vue__', '$options', 'name'], IDEA_LIST_ROW, node)) {
        return node.__vue__
      } else return this.getIdeaListRowVue(node.parentElement)
    },
    /**
     * This can be used to take user out of edit mode of idea
     */
    cancelIdeaEditing() {
      const active = document.activeElement
      if (active) {
        const ideaVue = this.getIdeaRowVue(active)
        if (ideaVue) {
          ideaVue.cancelIdeaEdit()
        } else {
          const ideaListVue = this.getIdeaListRowVue(active)
          ideaListVue && ideaListVue.cancelInlineEditing()
        }
      }
    },
    comment() {
      const selectedItem = keymapService.selectedListItem(this.$el)
      if (selectedItem && selectedItem.__vue__) {
        selectedItem.__vue__.showActivityModal({ focusAddCommentOnLoad: true })
        trackEvent(EVENT_CATEGORY.NAVIGATION, EVENT_ACTION.ACTIVITY_MODAL_KB, EVENT_NAME.IDEA)
      }
    },
    moveIdea() {
      let idea = this.getSelectedIdeaVueComponent()
      if (idea) {
        idea.showMoveIdea = true
      }
    },
    openActivityModal() {
      const idea = this.getSelectedIdeaVueComponent()
      if (idea) {
        idea.showActivityModal({ focusAddCommentOnLoad: true })
        trackEvent(EVENT_CATEGORY.NAVIGATION, EVENT_ACTION.ACTIVITY_MODAL_KB, EVENT_NAME.IDEA)
      }
    }
  }
}
